// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3o4Tn","title":"styles_title__1rDPN"};